import { useZero } from "@rocicorp/zero/react";
import { sharedMutators } from "../../shared/mutators";
import {
  WORKFLOW_LINK_CORNERS,
  type WorkflowLinkCorner,
  workflowLinkCorner,
} from "../../shared/workflowLink";
import { HelpTooltip } from "../components/HelpTooltip";
import { Icon } from "../components/Icon";
import { LabelWithInfo } from "../components/LabelWithInfo";

const CORNER_LABELS: Record<WorkflowLinkCorner, string> = {
  "top-left": "Top left",
  "top-right": "Top right",
  "bottom-left": "Bottom left",
  "bottom-right": "Bottom right",
};

export function useWorkflowLinkMenuItem({
  workflowId,
  hidden,
  corner,
  disabled,
}: {
  workflowId: string;
  hidden: boolean;
  corner: string | null;
  disabled: boolean;
}) {
  const z = useZero();
  const current = workflowLinkCorner(corner);
  const update = (change: { hidden?: boolean; corner?: WorkflowLinkCorner }) =>
    z.mutate(sharedMutators.updateWorkflowLink({ workflowId, ...change }));
  return {
    type: "submenu" as const,
    left: <Icon name="tines-mark" size={16} />,
    label: (
      <LabelWithInfo>
        <span>3B button</span>
        <HelpTooltip content="Adds an “Open in 3B” button to this workflow’s links, so people who can open the workflow can jump back to it." />
      </LabelWithInfo>
    ),
    disabled,
    submenu: [
      {
        items: [
          {
            type: "button" as const,
            key: "show",
            left: <Icon name="mouse-pointer-2" size={16} />,
            label: "Show on links",
            toggled: !hidden,
            keepOpen: true,
            onClick: () => update({ hidden: !hidden }),
          },
        ],
      },
      {
        label: "Corner",
        items: WORKFLOW_LINK_CORNERS.map((value) => ({
          type: "button" as const,
          key: value,
          left: null,
          label: CORNER_LABELS[value],
          right:
            current === value ? (
              <Icon name="check" size={12} color="var(--text-secondary)" />
            ) : null,
          onClick: () => update({ corner: value }),
        })),
      },
    ],
  };
}
